// extracted by mini-css-extract-plugin
export default {"CreateHighLevelLocation":"create-high-level-location_CreateHighLevelLocation__ASdwU"};